import comp from "./MiddlePane";
export default comp;
